import Quill from 'quill/core';
import type { Blot } from '../../../../types';
import findQuillByBlot from '../../../../utils/findQuillByBlot';

const selectBlotAndWaitMagneticWallUpdate = (blot: Blot): Promise<void> =>
  new Promise((resolve) => {
    const quill = findQuillByBlot(blot);
    if (!quill) {
      resolve();
      return;
    }

    quill.root.focus({ preventScroll: true });
    quill.setSelection(blot.offset(quill.scroll), 1, Quill.sources.USER);

    // Wait for MagneticWall to reset highlighted thread to null
    // since we've changed the selection
    setTimeout(() => {
      resolve();
    }, 100);
  });

export default selectBlotAndWaitMagneticWallUpdate;
